import { render, staticRenderFns } from "./addApproverDialog.vue?vue&type=template&id=29dbf8b2&scoped=true"
import script from "./addApproverDialog.vue?vue&type=script&lang=js"
export * from "./addApproverDialog.vue?vue&type=script&lang=js"
import style0 from "./addApproverDialog.vue?vue&type=style&index=0&id=29dbf8b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dbf8b2",
  null
  
)

export default component.exports